import fredericton from './cities/fredericton'

export default {
  'province': 'New Brunswick',
  'abbr': 'N.B.',
  'alpha': 'NB',
  'lawSociety': 'Law Society of New Brunswick',
  'writeup': '',
  'cities': [
    fredericton
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/newBrunswick/index.js